<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">

        <h1>Ann Arbor PPP Loans</h1>
      </div>

      <v-spacer></v-spacer>
      <div v-if="home">
      <a href="https://michigandaily.com"><v-img
        alt="MichiganDaily Logo"
        class="shrink mr-2"
        contain
        src="./assets/theM.jpg"
        transition="scale-transition"
        width="50"
      /></a></div>
      <div v-else>
      <a target="_blank" href="https://magnify.michigandaily.us/covidPPPtable/"><v-img
        alt="Expand Icon"
        class="shrink mr-2"
        contain
        src="./assets/open-in-new.png"
        transition="scale-transition"
        width="40"
      /></a></div>
    </v-app-bar>

    <v-main>
      <HelloWorld/>
    </v-main>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
  },

  data: () => ({
    home: true
  }),

  created(){
    if(window.self !== window.top){
      this.home = false
    }
  }
};
</script>
